import { Controller } from '@hotwired/stimulus'

const SIGNIFICANT = /[\d.,]/

export default class extends Controller {
  connect() {
    this.element.value = this.#formatted(this.element.value)
    this.element.dispatchEvent(new Event('change', { bubbles: true }))
  }

  format() {
    const caret = this.element.selectionStart ?? this.element.value.length
    const typed = this.#countSignificant(this.element.value.slice(0, caret))
    const formatted = this.#formatted(this.element.value)

    const caretAfterFormatting = this.#caretAfter(formatted, typed)

    this.element.value = formatted
    this.element.setSelectionRange(caretAfterFormatting, caretAfterFormatting)
  }

  #formatted(value) {
    const cleaned = value.replace(/\./g, ',').replace(/[^\d,]/g, '')
    if (cleaned === '') return ''

    const [units, ...rest] = cleaned.split(',')
    const grouped = new Intl.NumberFormat('fr-FR').format(Number(units || 0))
    if (!cleaned.includes(',')) return `${grouped} €`

    return `${grouped},${rest.join('').slice(0, 2)} €`
  }

  #countSignificant(text) {
    return [...text].filter((character) => SIGNIFICANT.test(character)).length
  }

  #caretAfter(text, count) {
    let seen = 0
    let position = 0

    for (let index = 0; index < text.length; index += 1) {
      if (!SIGNIFICANT.test(text[index])) continue

      seen += 1
      position = index + 1
      if (seen === count) break
    }

    return count === 0 ? 0 : position
  }
}
